import { ChevronRight } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import useTranslations from "containers/hooks/useLanguageHook";
import { Link } from "react-router-dom";
import routeConfig from "@config/routes";

function UnknownProviderComponent() {
  const { t } = useTranslations();
  return (
    <Box
      sx={{
        transform: `translate(0px,${Math.max(0, window.innerHeight / 2)}px)`,
      }}
    >
      <Typography variant="h3" align="center">
        {t.DataPage.UnknownProviderSankey}
      </Typography>

      <Stack sx={{ pt: 4 }} direction="row" spacing={2} justifyContent="center">
        <Button component={Link} size="large" variant="contained" color="primary" to={routeConfig.Application}>
          {t.LandingPage.LoadDataNow} <ChevronRight />
        </Button>
      </Stack>
    </Box>
  );
}
export default UnknownProviderComponent;
